import { type ActionEvent, Controller } from "@hotwired/stimulus"

import PriceRangeController from "./price_range_controller"
import { formatPrice } from "@/helpers/price_format"

export default class SearchBudgetController extends Controller {
  static outlets = ["price-range"]
  declare readonly priceRangeOutlet: PriceRangeController

  static targets = ["resetButton"]
  declare readonly resetButtonTarget: HTMLButtonElement
  declare readonly hasResetButtonTarget: boolean

  onRangeApplied(): void {
    if (this.hasResetButtonTarget) {
      this.resetButtonTarget.hidden = this.isDefaultSelected
    }
  }

  resetBudget(): void {
    this.priceRangeOutlet.reset()
    this.priceRangeOutlet.applyRange()
  }

  resetIfEmpty({ currentTarget }: ActionEvent): void {
    if (!(currentTarget as HTMLInputElement).value) {
      this.resetBudget()
    }
  }

  get isDefaultSelected(): boolean {
    return this.priceRangeOutlet.isDefaultBudget
  }

  get summaryText(): string {
    const lowerPrice = +this.priceRangeOutlet.lowerInputTarget.value
    const upperPrice = +this.priceRangeOutlet.upperInputTarget.value
    const formattedLowerPrice = formatPrice(lowerPrice)

    if (upperPrice === this.priceRangeOutlet.maxValue) {
      return `Any from ${formattedLowerPrice}`
    } else {
      return `${formattedLowerPrice} - ${formatPrice(upperPrice)}`
    }
  }
}
